module.exports = __webpack_public_path__ + "assets/img/33_167.b88b9eba.jpg";